import { createRouter, createWebHistory } from "vue-router";

import TestInfraFrontChildrens from "./test-infra-front/childrens";

const TestInfraFront = () => import("@/components/TestInfraFront.vue");

const routes = [
  {
    path: "/",
    component: TestInfraFront,
    children: TestInfraFrontChildrens,
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

// Plus de guard OIDC : l'auth est déléguée à l'edge.
// Le SPA est servi publiquement (local) ; un 401 sur un appel /api initie le login (cf. authMiddleware).
export default router;
